import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Content, User } from '../../models';
import { AuthenticationService, ContentService, UserService } from '../../services';

@Component({ templateUrl: 'manage-collaborator.dialog.html' })
export class ManageCollaboratorsDialog implements OnInit {
  public myControl = new FormControl();
  public filteredUsers: Observable<User[]>;
  public currentUser: User;
  public users: User[];
  public searchInput: string;
  public selected: User;
  constructor(
    private authService: AuthenticationService,
    private userService: UserService,
    private contentService: ContentService,
    public dialogRef: MatDialogRef<ManageCollaboratorsDialog>,
    @Inject(MAT_DIALOG_DATA) public content: Content) { }

  public ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUserCookie();
    this.getUsers();
  }
  public displayFn(user?: User): string | undefined {
    return user ? user.name : undefined;
  }
  public isInvalid() {
    const id: string = this.myControl && this.myControl.value && this.myControl.value._id ? this.myControl.value._id : null;
    return !id || id.length != 24;
  }
  public onAddCollaborator() {
    this.contentService.addCollaborator(this.content._id, this.myControl.value._id).subscribe((data) => {
      this.content = data;
      this.getUsers();
      this.myControl.setValue(null);
    });
  }
  public onRemoveCollaborator(user) {
    this.contentService.removeCollaborator(this.content._id, user._id).subscribe((data) => {
      this.content = data;
      this.getUsers();
    });
  }
  private getUsers() {
    this.userService.getAllByType(User.ROLE.DEVICE_MANAGER).subscribe((data) => {
      if (this.content.collaborators) {
        this.users = data.users.filter((u) => u._id != this.content.owner._id && !this.content.collaborators.find((c) => c._id == u._id));
      } else {
        this.users = data.users.filter((u) => u._id != this.content.owner._id);
      }
      this.filteredUsers = this.myControl.valueChanges
        .pipe(
          startWith<string | User>(''),
          map((value) => typeof value === 'string' ? value : (value && value.name) ? value.name : null),
          map((name) => name ? this._filter(name) : this.users.slice()),
        );
    });
  }
  private _filter(value): User[] {
    const filterValue = value && value.name ? value.name.toLowerCase() : value.toLowerCase();
    return this.users.filter((u) =>
      u.name.toLowerCase().includes(filterValue)
      || u.username.toLowerCase().includes(filterValue));
  }
}
